import React, { useEffect, useState } from "react";
import SpinnerLoader from "../components/SpinnerLoad/SpinnerLoader";
import { CODES } from "../utils/responseCodes";
import { simpleAlerts } from "../utils/alerts";
import NewsService from "../services/news";
import { Global } from "../utils/general";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


export const News = () => {
  const API_URL_STORAGE = Global.url_storage;

  const [titleSpinner, setTitleSpinner] = useState(null);
  const [openModalLoader, setOpenModalLoader] = useState(false);
  const [news, setNews] = useState([]);

  useEffect(() => {
    getNews();
  }, []);



  const getNews = async () => {
    try {
      setOpenModalLoader(true);
      setTitleSpinner("Buscando Noticias ...");
      const result = await NewsService.getNews();
      if (result.status === CODES.SUCCESS_200) {
        setNews(result.data);
      } else {
        simpleAlerts("Hubo un error al obtener las noticias", "error");
      }
    } catch (error) {
      console.log(`Error en getNews: ${error}`);
    } finally {
      setOpenModalLoader(false);
      setTitleSpinner(null);
    }
  };

  return (
    <div id="news" className="text-center">
      <Helmet>
        <title>ABX Shipping - Noticias</title>
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>Noticias</h2>
            <p>"Encantados de poder ayudarte."</p>
          </div>
        </div>

        {Object.keys(news).map((category, index) => (
          <div key={index} style={{ marginTop: "1rem" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              <h3
                style={{
                  fontWeight: "bold",
                  color: "#646568FF",
                  marginRight: "20px",
                  whiteSpace: "nowrap",
                }}
              >
                {category}
              </h3>
              <div
                style={{
                  flexGrow: 1,
                  height: "2px",
                  background:
                    "linear-gradient(to right, #33353AFF, transparent)",
                }}
              ></div>
            </div>

            <div className="row">
              {news[category].map((newsInfo) => (
                <div className="col-sm-4" key={newsInfo.id}>
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 6px 18px rgba(0, 0, 0, 0.1)",
                      marginBottom: "30px",
                      overflow: "hidden",
                      transition: "transform 0.3s",
                      minHeight: "450px",
                    }}
                    className="hover-card"
                  >
                    <img
                      src={`${API_URL_STORAGE}/${
                        newsInfo.images?.[0]?.url || "ruta/por_defecto.jpg"
                      }`}
                      alt={newsInfo.images?.[0]?.description || newsInfo.title}
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        //color: "#C00",
                        textAlign: "left",
                        padding: " 10px 0px 5px 20px",
                      }}
                    >
                      {new Date(
                        newsInfo.publication_date + "T12:00:00"
                      ).toLocaleDateString("es-PE", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </div>
                    <div
                      style={{
                        padding: " 0 20px 20px 20px",
                        textAlign: "left",
                      }}
                    >
                      <h4 style={{ fontWeight: "bold", color: "#333" }}>
                        {newsInfo.title}
                      </h4>
                      <p
                        style={{
                          color: "#555",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {newsInfo.summary}
                      </p>
                      <Link
                        to={`/news-details/${newsInfo.id}`}
                        style={{ color: "#2563eb", fontWeight: "bold" }}
                      >
                        Leer más →
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <SpinnerLoader open={openModalLoader} title={titleSpinner} />
    </div>
  );
};
